
export const generateURL=(data)=>{
    let params=data.params;
    if(url_mapper[data.id]){
        return url_mapper[data.id]({
            id:params.id
        })
    }else{
        return "#"
    }
}

const url_mapper={
    "REPORT_VIEW":({id})=>`/reports/inbox/${id}`,
    "TRANSACTION_DETAIL":({id})=>`/activity/${id}`
}

export const getBreadcrumb=(url="")=>{
    let urlArray=url.split("/");
    // console.log("URL AAR",urlArray,url)
    let routes=[];
    urlArray.map((item,index)=>{
        if(item==="" && index===0){
            routes.push({
                path:'/',
                breadcrumbName:'Home',
            })
        }
        else if(item==="" && index!==0){
            
        }
        else{
            // let _urlArray=JSON.parse(JSON.stringify(urlArray));

            routes.push({
                path:item,
                breadcrumbName:`${item.toUpperCase()}`,
                // url:_urlArray.slice(0,index+1).join('/')
            })
        }
    });
    // console.log("Route  is",routes)
    return routes;

}

const getBreadcrumbName=(_link)=>{


}

export const THEME_COLOR={
     "primary1":"#3851A3"
}

export const default_selections=[
    {
        display_name: "Amount",
        key: 'amount',
        type: 'decimal'
    },
    {
        display_name: "Txn Type",
        key: 'type',
        type: 'string'
    },
    {
        display_name: "Transaction Date",
        key: 'txn_date',
        type: 'date'
    },
    {
        display_name: "Description",
        key: 'description',
        type: 'string'
    },
    {
        display_name:"Transaction ID",
        key:'transaction_id',
        type:'string'
    }
]

export const setting_quick_menu=[
    // {
    //     title:"Datatypes",
    //     url:'/settings/datatype'
    //   },
    //   {
    //     title:"Data Repository",
    //     url:'/settings/data-repository'
    //   },
    //   {
    //     type:"main",
    //     title:"Sources",
    //     key:'sources',
    //     url:'/settings/sources'
    //   },
    {
        title:"Groups",
        url:"/settings/groups"
    },
    {
        title:"Data Repository",
        url:"/settings/data-repository"
    },
      {
        type:"main",
        title:"Tables",
        key:'tables',
        url:'/settings/tables'
      },
      {
        type:"main",
        title:"Plugins",
        key:'plugins',
        url:'/settings/plugins'
      },
    //   {
    //     type:"main",
    //     title:"Reconcilers",
    //     key:'reconcilers',
    //     url:'/settings/reconcilers-group'
    //   },
      {
        type:"main",
        title:"References",
        key:'references',
        url:'/settings/references'
      },
      {
        type:"main",
        title:"Users",
        key:'users',
        url:'/settings/users'
      },
      {
        type:'secondary',
        url:'/settings/logs/general',
        key:'general',
        title:'General Logs'
    },
    {
      type:'secondary',
      url:'/settings/logs/users',
      key:'users',
      title:'User Logs'
    },
    {
      type:'secondary',
      url:'/settings/logs/engine',
      key:'engine',
      title:'Engine Logs'
    },
    {
      type:'secondary',
      url:'/settings/logs/cron',
      key:'cron',
      title:'Cron Logs'
    }
    ,
    {
        type: "main",
        title: "Hooks",
        key: 'hooks',
        url: '/settings/hooks'
    },
    {
        type: "main",
        title: "Maker Checker",
        key: 'maker-checker',
        url: '/settings/maker-checker'
    },
      {
        type:"main",
        title:"Cron Configs",
        key:'cron_config',
        url:'/settings/cron'
      },
      {
        type:"main",
        title:"Maker Checker",
        key:'maker-checker',
        url:'/settings/maker-checker'
      },
      {
        type:"main",
        title:"App Settings",
        key:'app_settings',
        url:'/settings/app-settings'
      },
      {
        type:'main',
        title:'Import/Export',
        key:'import-export',
        url:'/settings/import-export'
      },
      {
        type:'main',
        title:'Clean/Reprocess',
        key:'clean-reprocess',
        url:'/settings/clean-reprocess'
      }
]

export const activity_quick_menu=[
            {
                title:"Fetchers",
                url:'/activity/fetcher'
            },
            {
                title: "Datatypes",
                url: '/activity/data-type',            
            },
            {
                title: "Tables",
                url: '/activity/table',            
            },
            {
                title:"Caches",
                url:'/activity/cache'
            },
            {
                title:"Failed Packets",
                url:'/activity/failed_packets'
            },
            {
                title:"Store Files",
                url:'/activity/store_file_count_list'
            }
]

export const recon_quick_menu=[
    {
        title:"Overview",
        url:'/recon/groups'
    },
    // {
    //     title:"Groups  ",
    //     url:'/recon/groups'
    // },
    // {
    //     title:"Transaction",
    //     url:'/recon/data-type'
    // },
    // {
    //     title:"Tables",
    //     url:'/recon/table'
    // }
]

export const reports_quick_menu=[
    {
        title:'Inbox',
        url:'/reports/inbox',
    },
    {
        title:'Archived',
        url:'/reports/archived',
    },
    {
        title:'Reports',
        url:'/reports/adhoc',
    },
    {
        title:'Report Settings',
        url:'/reports/settings',
    }
]

export const dashboard_quick_menu=[
    {
        title:"Today",
        url:'/dashboard/today'
    },
    {
        title:"All Pending",
        url:'/dashboard/pending'
    },
    // {
    //     title:"Transaction",
    //     url:'/recon/data-type'
    // },
    // {
    //     title:"Tables",
    //     url:'/recon/table'
    // }
]